import {useMemo} from "react";
import {css} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useOfferPagePromotionTrackingIds} from "../../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {scrollToElementById} from "../../../utils/scroll_to_element_by_id";
import {useApplicationFormPromotionInfo} from "../../hooks/use_application_form_promotion_info";

export const ApplicationFormPromotionPill = () => {
    const promotion = useApplicationFormPromotionInfo();
    const trackingIds = useOfferPagePromotionTrackingIds();

    const trackingContext = useMemo(() => {
        if (!promotion || !trackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: trackingIds.offerId,
            propertyId: trackingIds.propertyId,
            creativeSlot: "header_promotion_badge"
        });
    }, [promotion, trackingIds]);

    const handleScrollToPromotions = () => {
        if (trackingContext) {
            trackAmplitudeOfferSelectPromotion(trackingContext);
        }

        scrollToElementById(document.documentElement, "promocje", 100);
    };

    if (!promotion) {
        return null;
    }

    return (
        <button type="button" className={promotionPill} onClick={handleScrollToPromotions}>
            <div className={promotionPillIcon}>
                <PercentIcon size="2" wrapperSize="2" />
            </div>

            <Text variant="info_txt_1" strong>
                Deweloper oferuje promocje. <span className={promotionPillLink}>Zobacz</span>
            </Text>
        </button>
    );
};

const promotionPill = css({
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1.5,
    py: 1,
    appearance: "none",
    WebkitAppearance: "none",
    border: "none",
    color: "var(--colors-secondary)",
    font: "inherit",
    textAlign: "left",
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    borderRadius: "var(--radii-2)",
    mb: 2,
    cursor: "pointer",

    md: {
        mb: 0
    }
});

const promotionPillIcon = css({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const promotionPillLink = css({
    textDecoration: "underline",
    color: "inherit"
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {PercentIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useOfferPagePromotionTrackingIds} from "../../../promotion/hooks/use_offer_page_promotion_tracking_ids";
import {getAmplitudeOfferPagePromotionTrackingContext} from "../../../promotion/tracking/get_amplitude_offer_page_promotion_tracking_context";
import {trackAmplitudeOfferSelectPromotion} from "../../../promotion/tracking/track_amplitude_offer_promotion_events";
import {scrollToElementById} from "../../../utils/scroll_to_element_by_id";
import {useApplicationFormPromotionInfo} from "../../hooks/use_application_form_promotion_info";

export const ApplicationFormPromotionPill = () => {
    const promotion = useApplicationFormPromotionInfo();
    const trackingIds = useOfferPagePromotionTrackingIds();

    const trackingContext = useMemo(() => {
        if (!promotion || !trackingIds) {
            return null;
        }

        return getAmplitudeOfferPagePromotionTrackingContext({
            promotion,
            offerId: trackingIds.offerId,
            propertyId: trackingIds.propertyId,
            creativeSlot: "header_promotion_badge"
        });
    }, [promotion, trackingIds]);

    const handleScrollToPromotions = () => {
        if (trackingContext) {
            trackAmplitudeOfferSelectPromotion(trackingContext);
        }

        scrollToElementById(document.documentElement, "promocje", 100);
    };

    if (!promotion) {
        return null;
    }

    return (
        <button type="button" className={promotionPill} onClick={handleScrollToPromotions}>
            <div className={promotionPillIcon}>
                <PercentIcon size="2" wrapperSize="2" />
            </div>

            <Text variant="info_txt_1" strong>
                Deweloper oferuje promocje. <span className={promotionPillLink}>Zobacz</span>
            </Text>
        </button>
    );
};

const promotionPill = css({
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1.5,
    py: 1,
    appearance: "none",
    WebkitAppearance: "none",
    border: "none",
    color: "var(--colors-secondary)",
    font: "inherit",
    textAlign: "left",
    backgroundColor: "color-mix(in srgb, var(--colors-highlight) 30%, transparent)",
    borderRadius: "var(--radii-2)",
    mb: 2,
    cursor: "pointer",

    md: {
        mb: 0
    }
});

const promotionPillIcon = css({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const promotionPillLink = css({
    textDecoration: "underline",
    color: "inherit"
});
